import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from '../../store';

import CardWeather from './CarWeather';

interface WeatherProps {}

const Weather: React.FC<WeatherProps> = () => {
    const [forecast, setForecast] = useState<any>('');
    var { language } = useSelector((state: RootState) => state.lang);

    const getForecast = async () => {
        const response = await fetch(`https://api.openweathermap.org/data/2.5/forecast?q=Montreal&units=metric&APPID=dda3733b690c6f6095616b1c702adcc9`);
        const data = await response.json();
        const lang = language === 'EN' ? 'en-US' : 'fr-FR';
        if (data.list) {
            const weatherList = data.list;
            const fiveDayForecast: any[] = [];
            for (let i = 1; i < weatherList.length; i += 8) {
                const milliseconds = weatherList[i].dt * 1000;
                const day = new Date(milliseconds).toLocaleString(lang, { weekday: 'long' });
                const icon = weatherList[i].weather[0].icon;
                const description = weatherList[i].weather[0].main;
                const tempMin = Math.floor(weatherList[i].main.temp_min);
                const tempMax = Math.floor(weatherList[i].main.temp_max);
                fiveDayForecast.push([day.charAt(0).toUpperCase() + day.substr(1).toLowerCase(), icon, description, tempMin, tempMax]);
            }
            setForecast(fiveDayForecast);
        }
    };

    useEffect(() => {
        getForecast();
    }, [language]);

    if (forecast) {
        return forecast.map((data: any) => {
            const [day, icon, description, tempMin, tempMax] = data;
            return <CardWeather Title={day} Low={tempMin} High={tempMax} icon={icon} />;
        });
    } else {
        return <div>Loading</div>;
    }
};

export default Weather;
